export default function ProgressBar({ currentPage, totalPages }) {
  const safeTotalPages = Math.max(currentPage, totalPages);
  const rawPercentage = safeTotalPages > 0 ? ((currentPage - 1) / safeTotalPages) * 100 : 0;
  const percentage = Math.min(100, Math.max(0, Math.round(rawPercentage)));

  return (
    <div className="progress-container">
      <div className="progress">
        <div className="progress-bar" style={{ width: `${percentage}%` }} />
      </div>
      <p className="progress-text">
        <strong>Page {currentPage} of {safeTotalPages}</strong> (completed {percentage}%)
      </p>
    </div>
  );
}
